import React from 'react';
import { Wrapper } from './styles';
import ScotlandOnly from '../../assets/images/nav-map-scotland.svg';

const BounceCard = () => (
  <Wrapper>
    <img src={ScotlandOnly} alt="" />
    <div>
      <p>Housing laws differ between Scotland and England.</p>
      <p>
        This content applies to <strong>Scotland only.</strong>
      </p>
      <p>
        <a href="https://england.shelter.org.uk">
          Get advice if you're in England
        </a>
      </p>
    </div>
  </Wrapper>
);

export default BounceCard;
